z<template>
	<div class="">
		<div class="banners">
			<div class="main-container">
				<div class="">
					<div class="sidebar">
						<!-- <Sidebar/> -->
						<MainSidebar @sidebar-toggled="onSidebarToggled" />
					</div>
					<ProductToolbar />
					<div class="content" :style="contentStyle">
						<div class="row">
							<div class="col">
								<router-view />
							</div>
						</div>
					</div>
					<v-idle @idle="onidle" :duration="720"  style="display:none;"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import Sidebar from '../components/Sidebar.vue';
	import MainSidebar from '../components/MainSidebar.vue';
	import ProductToolbar from '../components/ProductToolbar.vue';

	export default {
		data() {
			return {
				isSidebarExpanded: window.innerWidth >= 992,
			}
		},

		components: {
			// Sidebar,
			MainSidebar,
			ProductToolbar
		},

		created() {
			// The new sidebar handles its own responsive logic, so we can remove the old listeners.
		},

		methods: {
			onSidebarToggled(isExpanded) {
				this.isSidebarExpanded = isExpanded;
			},

			onidle(){
				this.$store.commit('auth/setTokenExpires');
				this.$store.dispatch('auth/logout');
			}
		},
		computed: {
			contentStyle() {
				// On mobile, the sidebar overlays content, so no margin is needed.
				if (window.innerWidth <= 768) {
					return { marginLeft: '0px' };
				}
				// On desktop, adjust margin based on sidebar state.
				const sidebarWidth = this.isSidebarExpanded ? '260px' : '70px';
				return { marginLeft: sidebarWidth };
			},
		}
	}
</script>

<style scoped>
.content {
	padding-top: 66px; /* Height of the header */
	transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	padding-left: 50px; /* Add some padding for content */
	padding-right: 15px;
}
</style>